import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=204fb922&scoped=true&"
import script from "./Requirements.vue?vue&type=script&lang=js&"
export * from "./Requirements.vue?vue&type=script&lang=js&"
import style0 from "./Requirements.vue?vue&type=style&index=0&id=204fb922&scoped=true&lang=css&"
import style1 from "./Requirements.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204fb922",
  null
  
)

export default component.exports